import { useInputCompositionContext } from "../../../../../hooks/useInputCompositionContext/useInputCompositionContext";


import React, { useEffect } from "react";
import { setProjectAnnotations } from "@storybook/react";

const ICDescription = (
    {
        field,
        value,
        customStyle,
    }
) => {
    const [stateModel, setStateModel, isError, setIsError] = useInputCompositionContext();

    // useEffect(() => {
    //     console.log(isError);
    // }, [ isError]);

    return (
        <div className={`input-composition-default__description${
            customStyle
                ? " " + customStyle
                : ""}`}>
            {isError  &&
            isError[field] ? <span className={"input-composition-default__error-message"}>{isError[field]} </span>: value}
        </div>
    );
};

export default ICDescription;
